import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/clock-rotate-left-solid.svg'
import _imports_1 from '@/assets/chevron-left-solid.svg'
import _imports_2 from '@/assets/paper-plane-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-702f4b09"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "loader-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "header"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "When are you available to start your next load?", -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "header"
}
const _hoisted_9 = { class: "notify-header-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "actions" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "option-grid" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "center-button" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "time-mode"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_23 = { class: "time-select" }
const _hoisted_24 = { class: "hour-minute-select" }
const _hoisted_25 = { style: {"position":"relative"} }
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = {
  key: 1,
  class: "error"
}
const _hoisted_28 = ["value"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1))
const _hoisted_30 = { style: {"position":"relative"} }
const _hoisted_31 = {
  key: 0,
  class: "error"
}
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "meridiem-select" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "option-grid" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Today", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_41 = {
  key: 3,
  class: "notify-planner-mode"
}
const _hoisted_42 = { class: "actions" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!

  return (_ctx.commitError || typeof _ctx.driver === 'undefined')
    ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
        key: 0,
        message: _ctx.messageError
      }, null, 8, ["message"]))
    : (typeof _ctx.activeLoad === 'undefined' && !_ctx.commitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("main", _hoisted_4, [
          (!_ctx.isNotifyPlannerMode && !_ctx.isReturnHomeMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSetDateMode && _ctx.openSetDateMode(...args))),
                  class: "btn btn-link",
                  disabled: !_ctx.isSetTimeMode
                }, _toDisplayString(_ctx.selectedDateText), 9, _hoisted_7)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, [
                  _createTextVNode(" Thank you for confirming your availability to pick up a load "),
                  _hoisted_10,
                  _createElementVNode("span", null, [
                    (_ctx.todayOrTomorrowText)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_11, _toDisplayString(_ctx.todayOrTomorrowText), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(_ctx.todayOrTomorrowText && ',') + " ", 1),
                    (!_ctx.todayOrTomorrowText)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "on "))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.dateText) + " ", 1),
                    _createElementVNode("b", null, "at " + _toDisplayString(_ctx.timeText), 1),
                    _createTextVNode(". ")
                  ])
                ])
              ])),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.isSelectMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeOptions, (option) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: `time-option-${option.toMillis()}`,
                        onClick: ($event: any) => (_ctx.handleTimeOptionClicked(option)),
                        class: "btn btn-primary"
                      }, [
                        (option.diffNow('minutes').minutes < 30)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_17, "Now"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(option.toFormat('h:mm a')), 1))
                      ], 8, _hoisted_16))
                    }), 128)),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCustomOptionClicked && _ctx.handleCustomOptionClicked(...args))),
                        class: "btn btn-outline-primary icon-left"
                      }, [
                        _hoisted_20,
                        _createTextVNode(" Custom ")
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSetTimeMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSelectMode && _ctx.openSelectMode(...args))),
                    class: "btn btn-outline-primary icon-left"
                  }, [
                    _hoisted_22,
                    _createTextVNode(" Back ")
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, [
                        (_ctx.setTimeHourError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "1 - 12"))
                          : (_ctx.setTimePastError)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "can't be in past"))
                            : _createCommentVNode("", true),
                        _createElementVNode("input", {
                          class: _normalizeClass(_ctx.setTimeHourError && 'error'),
                          value: _ctx.customHour,
                          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleHourInput && _ctx.handleHourInput(...args))),
                          type: "text",
                          inputmode: "numeric"
                        }, null, 42, _hoisted_28)
                      ]),
                      _hoisted_29,
                      _createElementVNode("span", _hoisted_30, [
                        (_ctx.setTimeMinuteError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, "0 - 59"))
                          : _createCommentVNode("", true),
                        _createElementVNode("input", {
                          class: _normalizeClass(_ctx.setTimeMinuteError && 'error'),
                          value: _ctx.formattedMinute,
                          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleMinuteInput && _ctx.handleMinuteInput(...args))),
                          type: "text",
                          inputmode: "numeric"
                        }, null, 42, _hoisted_32)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", {
                        for: "pta-custom-meridiem-am",
                        class: _normalizeClass(_ctx.isAmSelected && 'selected')
                      }, [
                        _createTextVNode(" am "),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.meridiem) = $event)),
                          type: "radio",
                          value: "am",
                          name: "pta-custom-meridiem",
                          id: "pta-custom-meridiem-am"
                        }, null, 512), [
                          [_vModelRadio, _ctx.meridiem]
                        ])
                      ], 2),
                      _createElementVNode("label", {
                        for: "pta-custom-meridiem-pm",
                        class: _normalizeClass(_ctx.isPmSelected && 'selected')
                      }, [
                        _createTextVNode(" pm "),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.meridiem) = $event)),
                          type: "radio",
                          value: "pm",
                          name: "pta-custom-meridiem",
                          id: "pta-custom-meridiem-pm"
                        }, null, 512), [
                          [_vModelRadio, _ctx.meridiem]
                        ])
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleSetTimeDoneClicked && _ctx.handleSetTimeDoneClicked(...args))),
                    disabled: _ctx.disableSetTimeSubmit,
                    class: "btn btn-primary"
                  }, " Done ", 8, _hoisted_34)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSetDateMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleTodayDateOptionClicked && _ctx.handleTodayDateOptionClicked(...args))),
                      class: "btn btn-primary"
                    }, _hoisted_38),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateOptions, (option) => {
                      return (_openBlock(), _createElementBlock("button", {
                        onClick: ($event: any) => (_ctx.handleDateOptionClicked(option)),
                        key: `date-option-${option.toMillis()}`,
                        class: "btn btn-primary"
                      }, _toDisplayString(option.toFormat('EEE. MMM. d')), 9, _hoisted_39))
                    }), 128)),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-primary",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openSetTimeMode && _ctx.openSetTimeMode(...args)))
                      }, [
                        _hoisted_40,
                        _createTextVNode(" Back ")
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isNotifyPlannerMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" Notifying your planner in "),
                    _createElementVNode("b", null, _toDisplayString(_ctx.commitTimeout), 1),
                    _createTextVNode(" seconds... ")
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleNotifyPlannerChangeTimeClicked && _ctx.handleNotifyPlannerChangeTimeClicked(...args))),
                      class: "btn btn-outline-primary"
                    }, [
                      _hoisted_43,
                      _createTextVNode(" Change Time ")
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.commitChanges && _ctx.commitChanges(...args))),
                      class: "btn btn-primary"
                    }, [
                      _hoisted_44,
                      _createTextVNode(" Send Notification Now ")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
}